/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar1 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar1", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M16.492,21.543H14.7 v-5.43h-0.093l-1.699,1.147v-1.543l1.792-1.221h1.792V21.543z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar1.defaultProps = {
  className: null
};

IconCalendar1.propTypes = {
  className: PropTypes.string
};

export default IconCalendar1;
